<template>
  <div class="dyeingAndFinishingOrderDetail">
    <div class="steps">
      <Button v-print="`#da`"> 打印 </Button>
      <div class="grey" id="da">
        <table cellspacing="0" border="2">
          <tr>
            <td
              colspan="11"
              style="background: #f5f5f5;font-weight: 500;color: #333333;font-size: 24px; text-align: center;"
            >
              染整跟单
            </td>
          </tr>
          <!-- 胚布确认 -->
          <tr v-if="grepclothComfir.ztdpoContractNo">
            <td colspan="11" style="font-size: 18px;">
              胚布确认
            </td>
          </tr>
          <tr v-if="grepclothComfir.ztdpoContractNo">
            <td colspan="2">订单号</td>
            <td colspan="2">
              {{
                grepclothComfir && grepclothComfir.ztdpoContractNo
                  ? grepclothComfir.ztdpoContractNo
                  : "-"
              }}
            </td>
            <td>货号</td>
            <td>
              {{
                grepclothComfir && grepclothComfir.ztdpoArticleNumber
                  ? grepclothComfir.ztdpoArticleNumber
                  : "-"
              }}
            </td>
            <td>胚布货号</td>
            <td>
              {{
                grepclothComfir && grepclothComfir.ztdpoGreyFabricNumber1
                  ? grepclothComfir.ztdpoGreyFabricNumber1
                  : "-"
              }}
            </td>
            <td>加工单号</td>
            <td colspan="2">
              {{
                grepclothComfir && grepclothComfir.ztdpoDyeingOrderNumber
                  ? grepclothComfir.ztdpoDyeingOrderNumber
                  : "-"
              }}
            </td>
          </tr>
          <tr v-if="grepclothComfir.ztdpoContractNo">
            <td colspan="2">染厂</td>
            <td colspan="2">
              {{
                grepclothComfir && grepclothComfir.ztdpoCompanyName
                  ? grepclothComfir.ztdpoCompanyName
                  : "-"
              }}
            </td>
            <td>制单日期</td>
            <td>
              {{
                grepclothComfir && grepclothComfir.ztdpoFormDate
                  ? grepclothComfir.ztdpoFormDate
                  : "-"
              }}
            </td>
            <td>交货日期</td>
            <td>
              {{
                grepclothComfir && grepclothComfir.ztdpoOrderDeliveryDate
                  ? grepclothComfir.ztdpoOrderDeliveryDate
                  : "-"
              }}
            </td>
            <td>条距</td>
            <td colspan="2">
              {{
                grepclothComfir && grepclothComfir.ztdpoBarSpacing
                  ? grepclothComfir.ztdpoBarSpacing
                  : "-"
              }}
            </td>
          </tr>
          <tr v-if="grepclothComfir.ztdpoContractNo">
            <td colspan="2">品名</td>
            <td colspan="2">
              {{
                grepclothComfir && grepclothComfir.ztdpoProductName
                  ? grepclothComfir.ztdpoProductName
                  : "-"
              }}
            </td>
            <td>门幅</td>
            <td>
              {{
                grepclothComfir && grepclothComfir.ztdgcpLarghezza
                  ? grepclothComfir.ztdgcpLarghezza
                  : "-"
              }}
            </td>
            <td>克重</td>
            <td>
              {{ grepclothComfir && grepclothComfir.ztdgcpGram ? grepclothComfir.ztdgcpGram : "-" }}
            </td>
            <td>确认条距</td>
            <td colspan="2">
              {{
                grepclothComfir && grepclothComfir.ztdgcpSliverSpacing
                  ? grepclothComfir.ztdgcpSliverSpacing
                  : "-"
              }}
            </td>
          </tr>
          <tr v-if="grepclothComfir.ztdpoContractNo">
            <td colspan="2">成分</td>
            <td colspan="9">
              {{
                grepclothComfir && grepclothComfir.ztdpoIngredients
                  ? grepclothComfir.ztdpoIngredients
                  : "-"
              }}
            </td>
          </tr>
          <tr v-if="grepclothComfir.ztdpoContractNo">
            <td rowspan="2" colspan="2">工厂颜色</td>
            <td rowspan="2" colspan="2">
              {{
                grepclothComfir && grepclothComfir.ztdpoiFactoryColor
                  ? grepclothComfir.ztdpoiFactoryColor
                  : "-"
              }}
            </td>
            <td rowspan="2">工厂色号</td>
            <td rowspan="2">
              {{
                grepclothComfir && grepclothComfir.ztdpoiFactoryColorNumber
                  ? grepclothComfir.ztdpoiFactoryColorNumber
                  : "-"
              }}
            </td>
            <td rowspan="2">需求数(KGS)</td>
            <td rowspan="2">
              {{
                grepclothComfir && grepclothComfir.ztdpoiContractWeight
                  ? grepclothComfir.ztdpoiContractWeight
                  : "-"
              }}
            </td>
            <td rowspan="2">投胚数量</td>
            <td>匹数(匹)</td>
            <td>
              {{
                grepclothComfir && grepclothComfir.ztdpoiClothQuantity
                  ? grepclothComfir.ztdpoiClothQuantity
                  : "-"
              }}
            </td>
          </tr>
          <tr v-if="grepclothComfir.ztdpoContractNo" s>
            <td>重量(KG)</td>
            <td>
              {{
                grepclothComfir && grepclothComfir.ztdpoiPutInWeight
                  ? grepclothComfir.ztdpoiPutInWeight
                  : "-"
              }}
            </td>
          </tr>
          <!-- 松布缝头 -->
          <tr>
            <td colspan="11" style="font-size: 18px;">
              松布缝头
            </td>
          </tr>
          <tr>
            <td colspan="2">是否松布缝头</td>
            <td colspan="9">
              是
            </td>
          </tr>
          <!-- 汽平 -->
          <tr v-if="qp.qiPingInfo">
            <td colspan="11" style="font-size: 18px;">
              汽平
            </td>
          </tr>
          <tr v-if="qp.qiPingInfo">
            <td colspan="2">上机参数</td>
            <td>车速</td>
            <td colspan="3">
              {{
                qp && qp.qiPingInfo && qp.qiPingInfo.ztdqpUpSpeed ? qp.qiPingInfo.ztdqpUpSpeed : "-"
              }}
            </td>
            <td>温度</td>
            <td colspan="4">
              {{
                qp && qp.qiPingInfo && qp.qiPingInfo.ztdqpSteamUpTemperature
                  ? qp.qiPingInfo.ztdqpSteamUpTemperature
                  : "-"
              }}
            </td>
          </tr>
          <tr v-if="qp.qiPingInfo">
            <td colspan="2">下机参数</td>
            <td>门幅</td>
            <td colspan="3">
              {{
                qp && qp.qiPingInfo && qp.qiPingInfo.ztdqpSteamDownLarghezza
                  ? qp.qiPingInfo.ztdqpSteamDownLarghezza
                  : "-"
              }}
            </td>
            <td>克重</td>
            <td colspan="4">
              {{
                qp && qp.qiPingInfo && qp.qiPingInfo.ztdqpSteamDownGram
                  ? qp.qiPingInfo.ztdqpSteamDownGram
                  : "-"
              }}
            </td>
          </tr>
          <tr v-if="qp.qiPingInfo">
            <td colspan="2">备注</td>
            <td colspan="9">
              {{
                qp && qp.qiPingInfo && qp.qiPingInfo.ztdqpRemarks ? qp.qiPingInfo.ztdqpRemarks : "-"
              }}
            </td>
          </tr>
          <!-- 预定 -->
          <tr v-if="yuDingInfo.ztdypMachineSpeed">
            <td colspan="11" style="font-size: 18px;">
              预定
            </td>
          </tr>
          <tr v-if="yuDingInfo.ztdypMachineSpeed">
            <td colspan="2">车速</td>
            <td colspan="4">
              {{ yuDingInfo && yuDingInfo.ztdypMachineSpeed ? yuDingInfo.ztdypMachineSpeed : "-" }}
            </td>
            <td>温度</td>
            <td colspan="4">
              {{
                yuDingInfo && yuDingInfo.ztdypMachineTemperature
                  ? yuDingInfo.ztdypMachineTemperature
                  : "-"
              }}
            </td>
          </tr>
          <tr v-if="yuDingInfo.ztdypMachineSpeed">
            <td rowspan="2" colspan="2">上机</td>
            <td>门幅(cm)</td>
            <td>
              {{
                yuDingInfo && yuDingInfo.ztdypUpMachineLarghezza
                  ? yuDingInfo.ztdypUpMachineLarghezza
                  : "-"
              }}
            </td>
            <td rowspan="2">定中</td>
            <td>门幅(cm)</td>
            <td>
              {{
                yuDingInfo && yuDingInfo.ztdypMiddleMachineLarghezza
                  ? yuDingInfo.ztdypMiddleMachineLarghezza
                  : "-"
              }}
            </td>
            <td rowspan="2">下机</td>
            <td>门幅(cm)</td>
            <td colspan="2">
              {{
                yuDingInfo && yuDingInfo.ztdypDownMachineLarghezza
                  ? yuDingInfo.ztdypDownMachineLarghezza
                  : "-"
              }}
            </td>
          </tr>
          <tr v-if="yuDingInfo.ztdypMachineSpeed">
            <td>克重(GSM)</td>
            <td>
              {{
                yuDingInfo && yuDingInfo.ztdypUpMachineGram ? yuDingInfo.ztdypUpMachineGram : "-"
              }}
            </td>
            <td>克重(GSM)</td>
            <td>
              {{
                yuDingInfo && yuDingInfo.ztdypMiddleMachineGram
                  ? yuDingInfo.ztdypMiddleMachineGram
                  : "-"
              }}
            </td>
            <td>克重(GSM)</td>
            <td colspan="2">
              {{
                yuDingInfo && yuDingInfo.ztdypDownMachineLarghezza
                  ? yuDingInfo.ztdypDownMachineLarghezza
                  : "-"
              }}
            </td>
          </tr>
          <tr v-if="yuDingInfo.ztdypMachineSpeed">
            <td colspan="2">备注</td>
            <td colspan="9">
              {{ yuDingInfo && yuDingInfo.ztdypRemarks ? yuDingInfo.ztdypRemarks : "-" }}
            </td>
          </tr>
          <!-- 前处理 -->
          <tr v-if="qcl.qianChuLiInfo">
            <td colspan="11" style="font-size: 18px;">
              前处理
            </td>
          </tr>
          <tr v-if="qcl.qianChuLiInfo">
            <td colspan="2">是否烧毛</td>
            <td colspan="2">
              {{
                qcl && qcl.qianChuLiInfo && qcl.qianChuLiInfo.ztdqpShaomao
                  ? qcl.qianChuLiInfo.ztdqpShaomao == 1
                    ? "是"
                    : "否"
                  : "-"
              }}
            </td>
            <td colspan="2">是否蚀毛</td>
            <td colspan="2">
              {{
                qcl && qcl.qianChuLiInfo && qcl.qianChuLiInfo.ztdqpShimao
                  ? qcl.qianChuLiInfo.ztdqpShimao == 1
                    ? "是"
                    : "否"
                  : "-"
              }}
            </td>
            <td colspan="2">是否丝光</td>
            <td colspan="1">
              {{
                qcl && qcl.qianChuLiInfo && qcl.qianChuLiInfo.ztdqpSiguang
                  ? qcl.qianChuLiInfo.ztdqpSiguang == 1
                    ? "是"
                    : "否"
                  : "-"
              }}
            </td>
          </tr>
          <tr v-if="qcl.qianChuLiInfo">
            <td colspan="2">备注</td>
            <td colspan="9">
              {{
                qcl && qcl.qianChuLiInfo && qcl.qianChuLiInfo.ztdqpRemark
                  ? qcl.qianChuLiInfo.ztdqpRemark
                  : "-"
              }}
            </td>
          </tr>
          <!-- 染色 -->
          <tr v-if="rs.ranSeInfo">
            <td colspan="11" style="font-size: 18px;">
              染色
            </td>
          </tr>
          <tr v-if="rs.ranSeInfo">
            <td colspan="2">染色勾选</td>
            <td colspan="2">
              {{
                rs && rs.ranSeInfo && rs.ranSeInfo.zdrpChugang
                  ? rs.ranSeInfo.zdrpChugang == 1
                    ? "染底出缸"
                    : "套染出缸"
                  : "-"
              }}
            </td>
            <td colspan="2">门幅</td>
            <td colspan="2">
              {{ rs && rs.ranSeInfo && rs.ranSeInfo.zdrpMenfu ? rs.ranSeInfo.zdrpMenfu : "-" }}
            </td>
            <td colspan="2">克重</td>
            <td colspan="1">
              {{ rs && rs.ranSeInfo && rs.ranSeInfo.zdrpKezhong ? rs.ranSeInfo.zdrpKezhong : "-" }}
            </td>
          </tr>
          <!-- 过软 -->
          <tr v-if="gr.guoRuanInfo">
            <td colspan="11" style="font-size: 18px;">
              过软
            </td>
          </tr>
          <tr v-if="gr.guoRuanInfo">
            <td colspan="2">是否过软</td>
            <td colspan="9">
              {{
                gr && gr.guoRuanInfo && gr.guoRuanInfo.ztdgpGuoruan
                  ? gr.guoRuanInfo.ztdgpGuoruan == 1
                    ? "是"
                    : "否"
                  : "-"
              }}
            </td>
          </tr>
          <tr v-if="gr.guoRuanInfo">
            <td colspan="2">备注</td>
            <td colspan="9">
              {{
                gr && gr.guoRuanInfo && gr.guoRuanInfo.ztdgpRemarks
                  ? gr.guoRuanInfo.ztdgpRemarks
                  : "-"
              }}
            </td>
          </tr>
          <!-- 理压或脱水 -->
          <tr v-if="ly.liYaInfo">
            <td colspan="11" style="font-size: 18px;">
              理压或脱水
            </td>
          </tr>
          <tr v-if="ly.liYaInfo">
            <td colspan="2">是否理压或脱水</td>
            <td colspan="9">
              {{
                ly && ly.liYaInfo && ly.liYaInfo.ztdlpLiya
                  ? ly.liYaInfo.ztdlpLiya == 1
                    ? "是"
                    : "否"
                  : "-"
              }}
            </td>
          </tr>
          <!-- 是否破幅（或理布） -->
          <tr v-if="pf.poFuInfo">
            <td colspan="11" style="font-size: 18px;">
              是否破幅（或理布）
            </td>
          </tr>
          <tr v-if="pf.poFuInfo">
            <td colspan="2">是否破幅（或理布）</td>
            <td colspan="9">
              {{
                pf && pf.poFuInfo && pf.poFuInfo.ztdfoPofuStatus
                  ? pf.poFuInfo.ztdfoPofuStatus == 1
                    ? "是"
                    : "否"
                  : "-"
              }}
            </td>
          </tr>
          <!-- 水洗 -->
          <tr v-if="sx.shuiXiInfo">
            <td colspan="11" style="font-size: 18px;">
              水洗
            </td>
          </tr>
          <tr v-if="sx.shuiXiInfo">
            <td colspan="2">是否水洗</td>
            <td colspan="9">
              {{
                sx && sx.shuiXiInfo && sx.shuiXiInfo.ztdsxpShuixi
                  ? sx.shuiXiInfo.ztdsxpShuixi == 1
                    ? "是"
                    : "否"
                  : "-"
              }}
            </td>
          </tr>
          <!-- 干布 -->
          <tr v-if="ganBu.ganBuInfo">
            <td colspan="11" style="font-size: 18px;">
              干布
            </td>
          </tr>
          <tr v-if="ganBu.ganBuInfo">
            <td colspan="2">是否干布</td>
            <td colspan="9">
              {{
                ganBu && ganBu.ganBuInfo && ganBu.ganBuInfo.ztdgbpGanbu
                  ? ganBu.ganBuInfo.ztdgbpGanbu == 1
                    ? "是"
                    : "否"
                  : "-"
              }}
            </td>
          </tr>
          <!-- 成定 -->
          <tr v-if="chengDingInfo.ztdcpMachineSpeed">
            <td colspan="11" style="font-size: 18px;">
              成定
            </td>
          </tr>
          <tr v-if="chengDingInfo.ztdcpMachineSpeed">
            <td colspan="2">车速</td>
            <td colspan="3">
              {{
                chengDingInfo && chengDingInfo.ztdcpMachineSpeed
                  ? chengDingInfo.ztdcpMachineSpeed
                  : "-"
              }}
            </td>
            <td colspan="2">温度</td>
            <td colspan="4">
              {{
                chengDingInfo && chengDingInfo.ztdcpMachineTemperature
                  ? chengDingInfo.ztdcpMachineTemperature
                  : "-"
              }}
            </td>
          </tr>
          <tr v-if="chengDingInfo.ztdcpMachineSpeed">
            <td rowspan="2">上机</td>
            <td>门幅(cm)</td>
            <td>
              {{
                chengDingInfo && chengDingInfo.ztdcpUpMachineLarghezza
                  ? chengDingInfo.ztdcpUpMachineLarghezza
                  : "-"
              }}
            </td>
            <td rowspan="2">定中</td>
            <td>门幅(cm)</td>
            <td>
              {{
                chengDingInfo && chengDingInfo.ztdcpMiddleMachineLarghezza
                  ? chengDingInfo.ztdcpMiddleMachineLarghezza
                  : "-"
              }}
            </td>
            <td rowspan="2">下机</td>
            <td>门幅(cm)</td>
            <td colspan="3">
              {{
                chengDingInfo && chengDingInfo.ztdcpDownMachineLarghezza
                  ? chengDingInfo.ztdcpDownMachineLarghezza
                  : "-"
              }}
            </td>
          </tr>
          <tr v-if="chengDingInfo.ztdcpMachineSpeed">
            <td>克重(GSM)</td>
            <td colspan="2">
              {{
                chengDingInfo && chengDingInfo.ztdcpUpMachineGram
                  ? chengDingInfo.ztdcpUpMachineGram
                  : "-"
              }}
            </td>
            <td>克重(GSM)</td>
            <td colspan="2">
              {{
                chengDingInfo && chengDingInfo.ztdcpMiddleMachineGram
                  ? chengDingInfo.ztdcpMiddleMachineGram
                  : "-"
              }}
            </td>
            <td>克重(GSM)</td>
            <td colspan="3">
              {{
                chengDingInfo && chengDingInfo.ztdcpDownMachineGram
                  ? chengDingInfo.ztdcpDownMachineGram
                  : "-"
              }}
            </td>
          </tr>
          <tr v-if="chengDingInfo.ztdcpMachineSpeed">
            <td colspan="2">备注</td>
            <td colspan="9">
              {{
                chengDingInfo && chengDingInfo.ztdcpOtherRemarks
                  ? chengDingInfo.ztdcpOtherRemarks
                  : "-"
              }}
            </td>
          </tr>
          <tr v-if="chengDingInfo.ztdcpMachineSpeed">
            <td>缩率要求</td>
            <td>直缩(%)</td>
            <td>
              {{
                chengDingInfo && chengDingInfo.ztdcpStraightContraction
                  ? chengDingInfo.ztdcpStraightContraction
                  : "-"
              }}
            </td>
            <td>横缩(%)</td>
            <td>
              {{
                chengDingInfo && chengDingInfo.ztdcpTransverseContraction
                  ? chengDingInfo.ztdcpTransverseContraction
                  : "-"
              }}
            </td>
            <td>平纹(%)</td>
            <td>
              {{
                chengDingInfo && chengDingInfo.ztdcpPlainWeave ? chengDingInfo.ztdcpPlainWeave : "-"
              }}
            </td>
            <td>扭度(%)</td>
            <td>
              {{ chengDingInfo && chengDingInfo.ztdcpTwist ? chengDingInfo.ztdcpTwist : "-" }}
            </td>
            <td>PH值</td>
            <td>{{ chengDingInfo && chengDingInfo.ztdcpPh ? chengDingInfo.ztdcpPh : "-" }}</td>
          </tr>
          <tr v-if="chengDingInfo.ztdcpMachineSpeed">
            <td>色牢度要求</td>
            <td>水洗(级)</td>
            <td>
              {{
                chooseGrade(
                  chengDingInfo && chengDingInfo.ztdcpWashing ? chengDingInfo.ztdcpWashing : "-"
                )
              }}
            </td>
            <td>干磨(级)</td>
            <td>
              {{
                chooseGrade(
                  chengDingInfo && chengDingInfo.ztdcpDryFriction
                    ? chengDingInfo.ztdcpDryFriction
                    : "-"
                )
              }}
            </td>
            <td>湿磨(级)</td>
            <td>
              {{
                chooseGrade(
                  chengDingInfo && chengDingInfo.ztdcpWetFriction
                    ? chengDingInfo.ztdcpWetFriction
                    : "-"
                )
              }}
            </td>
            <td>光照(级)</td>
            <td>
              {{
                chooseGrade(
                  chengDingInfo && chengDingInfo.ztdcpIllumination
                    ? chengDingInfo.ztdcpIllumination
                    : "-"
                )
              }}
            </td>
            <td>汗渍(级)</td>
            <td>
              {{
                chooseGrade(
                  chengDingInfo && chengDingInfo.ztdcpSweatStain
                    ? chengDingInfo.ztdcpSweatStain
                    : "-"
                )
              }}
            </td>
          </tr>
          <tr v-if="chengDingInfo.ztdcpMachineSpeed">
            <td colspan="2">手感要求</td>
            <td colspan="3">
              {{
                chengDingInfo && chengDingInfo.ztdcpHandleRequirements
                  ? chengDingInfo.ztdcpHandleRequirements
                  : "-"
              }}
            </td>
            <td colspan="2">对色光源</td>
            <td colspan="4">
              {{
                chengDingInfo && chengDingInfo.ztdcpColorSource
                  ? chengDingInfo.ztdcpColorSource
                  : "-"
              }}
            </td>
          </tr>
          <tr v-if="chengDingInfo.ztdcpMachineSpeed">
            <td colspan="2">合理损耗及计算方法</td>
            <td colspan="9">
              {{
                chengDingInfo && chengDingInfo.ztdcpReasonableLoss
                  ? chengDingInfo.ztdcpReasonableLoss
                  : "-"
              }}
            </td>
          </tr>
          <!-- 后整理 -->
          <tr v-if="houZhengli.houZhengLiInfo">
            <td colspan="11" style="font-size: 18px;">
              后整理
            </td>
          </tr>
          <tr v-if="houZhengli.houZhengLiInfo">
            <td colspan="2">是否剪毛</td>
            <td colspan="9">
              {{
                houZhengli && houZhengli.houZhengLiInfo && houZhengli.houZhengLiInfo.ztdhpJianmao
                  ? houZhengli.houZhengLiInfo.ztdhpJianmao == 1
                    ? "是"
                    : "否"
                  : "-"
              }}
            </td>
          </tr>
          <tr v-if="houZhengli.houZhengLiInfo">
            <td colspan="2">是否预缩</td>
            <td colspan="9">
              {{
                houZhengli && houZhengli.houZhengLiInfo && houZhengli.houZhengLiInfo.ztdhpGuoyusuoji
                  ? houZhengli.houZhengLiInfo.ztdhpGuoyusuoji == 1
                    ? "是"
                    : "否"
                  : "-"
              }}
            </td>
          </tr>
          <tr v-if="houZhengli.houZhengLiInfo">
            <td colspan="2">备注</td>
            <td colspan="9">
              {{
                houZhengli && houZhengli.houZhengLiInfo && houZhengli.houZhengLiInfo.ztdhpRemarks
                  ? houZhengli.houZhengLiInfo.ztdhpRemarks
                  : "-"
              }}
            </td>
          </tr>
          <!-- 染厂/定型厂/打包进仓 -->
          <tr v-if="daBao.daBaoInfo">
            <td colspan="11" style="font-size: 18px;">
              染厂/定型厂/打包进仓
            </td>
          </tr>
          <tr v-if="daBao.daBaoInfo">
            <td colspan="2">总米数</td>
            <td colspan="3">
              {{
                daBao && daBao.daBaoInfo && daBao.daBaoInfo.ztddpPishu
                  ? daBao.daBaoInfo.ztddpPishu
                  : "-"
              }}
            </td>
            <td colspan="2">总公斤数</td>
            <td colspan="4">
              {{
                daBao && daBao.daBaoInfo && daBao.daBaoInfo.ztddpGongjing
                  ? daBao.daBaoInfo.ztddpGongjing
                  : "-"
              }}
            </td>
          </tr>
          <tr v-if="daBao.daBaoInfo">
            <td colspan="2">备注</td>
            <td colspan="9">
              {{
                daBao && daBao.daBaoInfo && daBao.daBaoInfo.ztddpRemarks
                  ? daBao.daBaoInfo.ztddpRemarks
                  : "-"
              }}
            </td>
          </tr>
          <!-- 是否提供船样给业务确认信息 -->
          <tr v-if="chuanYang.chuanYangInfo">
            <td colspan="11" style="font-size: 18px;">
              是否提供船样给业务确认信息
            </td>
          </tr>
          <tr v-if="chuanYang.chuanYangInfo">
            <td colspan="2" class="greyBackground" style="width:220px">
              是否提供船样给业务确认信息
            </td>
            <td colspan="9">
              {{
                chuanYang && chuanYang.chuanYangInfo && chuanYang.chuanYangInfo.ztdcypStatus
                  ? chuanYang.chuanYangInfo.ztdcypStatus == 1
                    ? "是"
                    : "否"
                  : "-"
              }}
            </td>
          </tr>
          <!-- 业务确认 -->
          <tr v-if="businessConfirmInfo.status">
            <td colspan="11" style="font-size: 18px;">
              业务确认
            </td>
          </tr>
          <tr v-if="businessConfirmInfo.status">
            <td colspan="2">审核结果</td>
            <td colspan="9">
              {{
                chooseConfirm(
                  businessConfirmInfo && businessConfirmInfo.status
                    ? businessConfirmInfo.status
                    : "-"
                )
              }}
            </td>
          </tr>
          <tr v-if="businessConfirmInfo.status">
            <td colspan="2">审核意见</td>
            <td colspan="9">
              {{
                businessConfirmInfo && businessConfirmInfo.ztdfoBusinessReviewComments
                  ? businessConfirmInfo.ztdfoBusinessReviewComments
                  : "-"
              }}
            </td>
          </tr>
          <tr>
            <td colspan="2">审核结果</td>
            <td colspan="9">
              {{
                chooseConfirm(
                  yeWu1.yeWu1Info && yeWu1.yeWu1Info.ztdfoBusinessConfirmationStatus1
                    ? yeWu1.yeWu1Info.ztdfoBusinessConfirmationStatus1
                    : "-"
                )
              }}
            </td>
          </tr>
          <tr v-if="yeWu1.yeWu1Info">
            <td colspan="2">审核意见</td>
            <td colspan="9">{{ yeWu1.yeWu1Info.ztdfoBusinessReviewComments1 }}</td>
          </tr>
          <tr v-if="yeWu2.yeWu2Info">
            <td colspan="2">审核结果</td>
            <td colspan="9">
              {{
                chooseConfirm(
                  yeWu2.yeWu2Info && yeWu2.yeWu2Info.ztdfoBusinessConfirmationStatus2
                    ? yeWu2.yeWu2Info.ztdfoBusinessConfirmationStatus2
                    : "-"
                )
              }}
            </td>
          </tr>
          <tr v-if="yeWu2.yeWu2Info">
            <td colspan="2">审核意见</td>
            <td colspan="9">{{ yeWu2.yeWu2Info.ztdfoBusinessReviewComments2 }}</td>
          </tr>
          <tr v-if="yeWu3.yeWu3Info">
            <td colspan="2">审核结果</td>
            <td colspan="9">
              {{
                chooseConfirm(
                  yeWu3.yeWu3Info && yeWu3.yeWu3Info.ztdfoBusinessConfirmationStatus3
                    ? yeWu3.yeWu3Info.ztdfoBusinessConfirmationStatus3
                    : "-"
                )
              }}
            </td>
          </tr>
          <tr v-if="yeWu3.yeWu3Info">
            <td colspan="2">审核意见</td>
            <td colspan="9">{{ yeWu3.yeWu3Info.ztdfoBusinessReviewComments3 }}</td>
          </tr>
          <!-- 解决方案 -->
          <tr v-if="!fangAn1.fangAn1Info && !fangAn2.fangAn2Info && !fangAn3.fangAn3Info">
            <td colspan="11" style="font-size: 18px;">
              解决方案
            </td>
          </tr>
          <tr v-if="fangAn1.fangAn1Info">
            <td colspan="2">备注</td>
            <td colspan="9">{{ fangAn1.fangAn1Info.ztdfoSolutionComments1 }}</td>
          </tr>
          <tr v-if="fangAn2.fangAn2Info">
            <td colspan="2">备注</td>
            <td colspan="9">{{ fangAn2.fangAn2Info.ztdfoSolutionComments2 }}</td>
          </tr>
          <tr v-if="fangAn3.fangAn3Info">
            <td colspan="2">备注</td>
            <td colspan="9">{{ fangAn3.fangAn3Info.ztdfoSolutionComments3 }}</td>
          </tr>
          <!-- 业务确认 -->
          <!-- <tr>
            <td colspan="11" style="font-size: 18px;">
              业务确认
            </td>
          </tr> -->
        </table>

        <div class="endOfPrint">
          <div>跟单员：{{ followerName }}</div>
          <div>业务担当：{{ ztdpoPlanningResponsibility }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ztdpoPlanningResponsibility: "", // 业务担当
      followerName: "", // 跟单员
      grepclothComfir: {}, // 胚布确认信息
      yuDingInfo: {}, // 预定信息
      chengDingInfo: {}, // 成定信息
      businessConfirmInfo: {}, // 业务信息确认
      chengDingInfo_second: {}, // 二次成定信息
      businessConfirmInfo_second: {}, // 二次业务确认
      qp: {}, // 汽平
      qcl: {}, // 前处理
      rs: {}, // 染色
      gr: {}, // 过软
      ly: {}, // 理压
      sx: {}, // 水洗
      daBao: {}, // 染厂/定型厂/打包进仓
      chuanYang: {}, // 是否提供船样给业务确认信息
      ganBu: {}, // 干布
      pf: {}, // 破幅（或理布）
      houZhengli: {},
      yeWu1: {}, // 业务处理1
      yeWu2: {}, // 业务处理2
      yeWu3: {}, // 业务处理3
      fangAn1: {}, // 解决方案1
      fangAn2: {}, // 解决方案2
      fangAn3: {}, // 解决方案3
      imgList: {} // 图片数组
    };
  },
  created() {
    this.followerName = this.$route.query.followerName || "";
    this.ztdpoPlanningResponsibility = this.$route.query.ztdpoPlanningResponsibility || "";
    this.getOrderStatus();
  },
  methods: {
    // 获取订单详情信息
    getOrderStatus() {
      this.axios({
        url: "/dtsum/zongtong/dyeing/WebDyeingController/dyeingPlanOrderSheetInfo",
        method: "get",
        params: {
          params: {
            dyeingOrderNumber: this.$route.query.dyeingOrderNumber,
            contractNo: this.$route.query.contract,
            followerName: this.$route.query.followerName,
            ztdpoStatus: this.$route.query.ztdpoStatus
          }
        }
      })
        .then(res => {
          if (res.data.success === 1) {
            const body = res.data.body;
            this.grepclothComfir = JSON.parse(JSON.stringify(body.grepclothComfir));
            this.yuDingInfo = JSON.parse(JSON.stringify(body.yuDingInfo));
            this.chengDingInfo = JSON.parse(JSON.stringify(body.chengDingInfo));
            this.businessConfirmInfo = JSON.parse(JSON.stringify(body.businessConfirmInfo));
            this.qp = JSON.parse(JSON.stringify(body.qp));
            this.qcl = JSON.parse(JSON.stringify(body.qcl));
            this.rs = JSON.parse(JSON.stringify(body.rs));
            this.gr = JSON.parse(JSON.stringify(body.gr));
            this.ly = JSON.parse(JSON.stringify(body.ly));
            this.sx = JSON.parse(JSON.stringify(body.sx));
            this.ganBu = JSON.parse(JSON.stringify(body.ganBu));
            this.houZhengli = JSON.parse(JSON.stringify(body.houZhengli));
            this.daBao = JSON.parse(JSON.stringify(body.daBao));
            this.chuanYang = JSON.parse(JSON.stringify(body.chuanYang));
            this.pf = JSON.parse(JSON.stringify(body.pf));
            this.yeWu1 = JSON.parse(JSON.stringify(body.yeWu1));
            this.yeWu2 = JSON.parse(JSON.stringify(body.yeWu2));
            this.yeWu3 = JSON.parse(JSON.stringify(body.yeWu3));
            this.fangAn1 = JSON.parse(JSON.stringify(body.fangAn1));
            this.fangAn2 = JSON.parse(JSON.stringify(body.fangAn2));
            this.fangAn3 = JSON.parse(JSON.stringify(body.fangAn3));
            // this.chengDingInfo_second = JSON.parse(JSON.stringify(body.chengDingInfo_second))
            // this.businessConfirmInfo_second = JSON.parse(JSON.stringify(body.businessConfirmInfo_second))
            this.imgList = JSON.parse(JSON.stringify(body.imgList));
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 选择级数
    chooseGrade(value) {
      switch (value) {
        case 1:
          return "一级";
        case 2:
          return "二级";
        case 3:
          return "三级";
        case 4:
          return "四级";
        case 5:
          return "五级";
        case 6:
          return "六级";
        case 7:
          return "七级";
        case 8:
          return "八级";
        default:
          return "-";
      }
    },
    // 选择审核结果
    chooseConfirm(value) {
      switch (value) {
        case 0:
          return "待确认";
        case 1:
          return "通过";
        case 2:
          return "不通过";
        default:
          return "-";
      }
    },
    // 选择当前步骤
    chooseStatus() {
      switch (this.$route.query.ztdpoStatus) {
        case "0":
          return "待胚布确认";
        case "1":
          return "待缝头";
        case "2":
          return "待汽平";
        case "3":
          return "待预定";
        case "4":
          return "待前处理";
        case "5":
          return "待染色";
        case "6":
          return "待过软";
        case "7":
          return "待理压脱水";
        case "8":
          return "待破幅";
        case "9":
          return "待水洗";
        case "10":
          return "待干布";
        case "11":
          return "待成定";
        case "12":
          return "待后整理";
        case "13":
          return "待进仓";
        case "14":
          return "待提供业务确认";
        case "15":
          return "待业务确认";
        case "16":
          return "待回仓";
        case "17":
          return "已完成";
        default:
          return "未知";
      }
    }
  }
};
</script>
>
<style lang="scss" scoped>
.dyeingAndFinishingOrderDetail {
  font-family: Source Han Sans CN;
}
.endOfPrint {
  display: flex;
  font-size: 24px;
  color: #000;
  div {
    margin: 10px 300px 0 10px;
  }
}
table {
  width: 100%;
  border: 1px solid #b3a2a2;
  border-collapse: collapse;
  color: #000;
  table-layout: fixed;
  tr {
    height: 37px;
    td {
      padding: 5px;
      border: 1px solid #dcdada;
    }
  }
}
@media print {
  body * {
    visibility: hidden; /* 隐藏所有元素 */
  }
  #da,
  #da * {
    visibility: visible; /* 只显示打印区域 */
  }
  .grey {
    page-break-after: always; /* 每张卡片后分页 */
    page-break-inside: avoid; /* 避免内容被分割 */
    height: 100vh; /* 确保每项占满一页 */
    margin: 0;
    padding: 0;
  }
  table {
    width: 100%;
    padding: 5px;
    color: #000;
    border-collapse: collapse;
  }
}
</style>
